// English translations
import enCommon from './locales/en/common.json';
import enAuth from './locales/en/auth.json';
import enOrders from './locales/en/orders.json';
import enAdmin from './locales/en/admin.json';
import enErrors from './locales/en/errors.json';
import enHome from './locales/en/home.json';

// Vietnamese translations
import viCommon from './locales/vi/common.json';
import viAuth from './locales/vi/auth.json';
import viOrders from './locales/vi/orders.json';
import viAdmin from './locales/vi/admin.json';
import viErrors from './locales/vi/errors.json';
import viHome from './locales/vi/home.json';

// Supported languages
export const supportedLanguages = ['en', 'vi'] as const;
export type SupportedLanguage = (typeof supportedLanguages)[number];

// Default language
export const defaultLanguage: SupportedLanguage = 'vi';

// Fallback language (used when a translation is missing)
export const fallbackLanguage: SupportedLanguage = 'en';

// Namespace definitions
export const namespaces = ['common', 'auth', 'orders', 'admin', 'errors', 'home'] as const;
export type Namespace = (typeof namespaces)[number];

// Default namespace
export const defaultNamespace: Namespace = 'common';

// Resources organized by language and namespace
export const resources = {
  en: {
    common: enCommon,
    auth: enAuth,
    orders: enOrders,
    admin: enAdmin,
    errors: enErrors,
    home: enHome,
  },
  vi: {
    common: viCommon,
    auth: viAuth,
    orders: viOrders,
    admin: viAdmin,
    errors: viErrors,
    home: viHome,
  },
} as const;

// Type for translation resources
export type TranslationResources = typeof resources;

// Language display names
export const languageNames: Record<SupportedLanguage, string> = {
  en: 'English',
  vi: 'Tiếng Việt',
};

// Export individual translation files for direct access if needed
export const translations = {
  en: {
    common: enCommon,
    auth: enAuth,
    orders: enOrders,
    admin: enAdmin,
    errors: enErrors,
    home: enHome,
  },
  vi: {
    common: viCommon,
    auth: viAuth,
    orders: viOrders,
    admin: viAdmin,
    errors: viErrors,
    home: viHome,
  },
};

export default resources;
